/**
 * Recommendation block below detail pages (inc/related-content.php).
 *
 * The visible cards are fixed in the cached HTML, so crawlers always see the
 * same links. Spare cards wait in a <template>: once per page load, a visible
 * card whose venue is closed right now (Berlin time) is swapped for the first
 * open spare of the same group. Cards without known hours never move.
 */

import {
  computeOpeningStatus,
  getBerlinClock,
  parsePeriodsAttribute,
  parseSpecialAttribute,
  refreshAllOpeningStatuses,
} from "./opening-hours-status";

function slotStatus(slot, clock) {
  const periods = parsePeriodsAttribute(slot.getAttribute("data-periods"));
  const special = parseSpecialAttribute(slot.getAttribute("data-special"));

  if (!periods.length && !special.length) {
    return null;
  }

  return computeOpeningStatus(periods, { special, clock, compact: true });
}

function swapClosedSlots(section) {
  const grid = section.querySelector("[data-related-grid]");
  const template = section.querySelector("template[data-related-reserve]");

  if (!grid || !template) {
    return;
  }

  const clock = getBerlinClock();
  const spares = Array.from(
    template.content.querySelectorAll("[data-related-slot][data-related-group]"),
  ).filter((spare) => slotStatus(spare, clock)?.open);

  grid
    .querySelectorAll(":scope > [data-related-slot][data-related-group]")
    .forEach((slot) => {
      const status = slotStatus(slot, clock);

      if (!status || status.open || status.state === "unknown") {
        return;
      }

      const index = spares.findIndex(
        (spare) => spare.dataset.relatedGroup === slot.dataset.relatedGroup,
      );

      if (index === -1) {
        return;
      }

      const [spare] = spares.splice(index, 1);
      slot.replaceWith(document.importNode(spare, true));
    });

  refreshAllOpeningStatuses({ root: grid, clock });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-related]").forEach(swapClosedSlots);
});
